import { useMutation } from "@apollo/client";
import {
  GetOrderByIdDocument,
  RemoveOrderProductDocument,
} from "../../gql/generated/graphql";

interface Props {
  orderId: string;
}

export const useRemoveOrderProduct = ({ orderId }: Props) => {
  const [removeOrderProduct] = useMutation(RemoveOrderProductDocument, {
    refetchQueries: [GetOrderByIdDocument],
  });

  return {
    removeOrderProduct: async (productId: string) => {
      await removeOrderProduct({
        variables: {
          orderId,
          productId,
        },
      });
    },
  };
};
